'use client';
import {PropsWithChildren, useEffect, useState} from 'react';
import NavBreadcrumb from '../NavBreadcrumb';

type Props = {
  title: string;
  paths: {label: string; path?: string}[];
} & PropsWithChildren;

export default function VillagesHeaderRoot({title, paths, children}: Props) {
  const [headerTop, setHeaderTop] = useState<number | undefined>(undefined);

  useEffect(() => {
    const handleScroll = () => {
      const headerElement = document.querySelector('#header-root');
      const headerGhost = document.querySelector('#header-ghost');
      const scrollTop = window.scrollY;

      if (headerTop !== undefined && scrollTop > headerTop) {
        headerElement?.classList.add('is-sticky');
        headerGhost?.classList.add('active');
      } else {
        headerElement?.classList.remove('is-sticky');
        headerGhost?.classList.remove('active');
      }
    };

    const headerElement = document.querySelector('#header-root');
    if (headerElement) {
      const rect = headerElement.getBoundingClientRect();
      setHeaderTop(rect.top + window.scrollY);
    }

    window.scrollTo({top: 0});

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [headerTop]);

  return (
    <div
      id="header-root"
      className="w-full relative top-0 bg-white transition-shadow duration-300 ease-in-out [&.is-sticky]:desktop:fixed [&.is-sticky]:desktop:z-[19] [&.is-sticky]:desktop:shadow-default">
      <div className="w-full max-w-[100%] px-sm md:px-md desktop:px-lg mx-auto flex flex-col mb-4 pt-2">
        <h1 className="mb-0 text-title font-title">{title}</h1>
        <NavBreadcrumb.Root className="text-gray-600 !py-0">
          {paths?.map(({path, label}, index) => (
            <NavBreadcrumb.Item key={index} path={path}>
              {label}
            </NavBreadcrumb.Item>
          ))}
        </NavBreadcrumb.Root>
        {children}
      </div>
    </div>
  );
}
